import { render, staticRenderFns } from "./WholesaleInviteWidget.vue?vue&type=template&id=13b9ce3c&scoped=true&"
import script from "./WholesaleInviteWidget.vue?vue&type=script&lang=js&"
export * from "./WholesaleInviteWidget.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleInviteWidget.vue?vue&type=style&index=0&id=13b9ce3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9ce3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
